var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main",style:(_vm.$theme.background ? { backgroundImage: 'url(' + _vm.$theme.background + ')' } : { backgroundColor: '#eef0f3' }),attrs:{"id":"app"}},[_c('cyb-tool-bar'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }